import { Header } from "./styledSetProfileHeader";

export default function SetprofileHeader() {
  return (
    <Header>
      <h2>프로필 설정</h2>
      <p>나중에 언제든지 변경할 수 있습니다.</p>
    </Header>
  );
}
